import {ReactNode} from "react"
import {z} from "zod"
import { useContentContext } from "./ContentProvider"
import {plateNumberRegex, postalCodeRegex, socialSecurityNumberRegex} from "./options"

export interface ComponentProps {
  children?: ReactNode
}

export type Content = {
  lang: string,
  translations: { // TODO Generate full typings
    detailsForm: any,
    results: any,
    notFound: any,
    singleResult: any
    footer: any
  }
}

export interface ResultRowInterface {
  place: number,
  insuranceCompanyName: string,
  productName: string,
  group: string,
  price: number,
  rating: {
    epsi: number,
    insurerepsi: number,
    negative: Array<Rating>,
    positive: Array<Rating>,
  },
  coverages: Array<{ name: string, rating?: number, text?: string }>
  onShowInsuranceCompany: () => void
  token: string
  gclid: string
}

export interface ModalInterface {
  open: boolean,
  setOpen: (open: boolean) => void,
  cancelButtonRef: any,
  title: string,
  description: string,
  buttonTitle: string,
}

export const SignUpSchema = z.object({
  vehicleType: z.string(),
  plateNumber: z.string().regex(plateNumberRegex),
  annualMileage: z.number(),
  under25Driver: z.enum(["true", "false"]),
  mainUser: z.enum(["true", "false"]),
  carFinanced: z.enum(["true", "false"]),
  professionalUse: z.enum(["true", "false"]),
  socialSecurityNumber: z.string().regex(socialSecurityNumberRegex),
  postalNumber: z.string().regex(postalCodeRegex),
})

export type SignUpSchemaType = z.infer<typeof SignUpSchema>

export const resultTabs = [
  {name: 'Best Price', href: '#', current: true},
  {name: 'Best Rating', href: '#', current: false},
]

export interface Highlight {
  included: string
  text: string
}

export interface Coverage {
  name: string
}

export interface Addon {
  name: string
  price: null | number
  optional: boolean
  selected: boolean
}

export interface OptionItem {
  name: string
  commonName: string
}

export interface Rating {
  icon: number,
  note: string
}

export interface ResultRow {
  quoteId: number
  matrixId: number
  group: string
  addons: null | Addon[]
  insuranceCompany: { name: string, url: string }
  productName: string
  price: string
  priceValue: number,
  rating: {
    epsi: number,
    insurerepsi: number,
    negative: Array<Rating>,
    positive: Array<Rating>,
  },
  coverages: Coverage[]
}

export interface ResultFilterProps {
  plateNumber: string
  currentLevelOfCover: string
  currentOptional: string[]
  currentRating: string
  currentPartners: string[]
  results: ResultRow[]
  allResults?: ResultRow[]
  handleLevelOfCover: (value: string) => void
  handleOptional: (value: string) => void
  handleFilterByRating: (value: string) => void
  handlePartner: (value: string) => void
  handleGoBack: () => void
  filterOptions: OptionItem[]
}

export const toPascalCase = (str: string) => {
  return `${str}`
    .replace(new RegExp(/[-_]+/, "g"), " ")
    .replace(new RegExp(/[^\w\s]/, "g"), "")
    .replace(
      new RegExp(/\s+(.)(\w+)/, "g"),
      ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`
    )
    .replace(new RegExp(/\s/, "g"), "")
    .replace(new RegExp(/\w/), (s) => s.toUpperCase())
}

export const toCapitalFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export enum FilterType {
  LEVEL_OF_COVER = "levelOfCover",
  OPTIONAL = "optional",
  RATING = "rating"
}
